import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';
import { motion } from 'framer-motion';

type NavSelectedIndicatorProps = {
	className?: string;
	groupId?: string;
};

const NavSelectedIndicator = ({ className, groupId = 'default' }: NavSelectedIndicatorProps) => {
	const classes = twMerge(
		clsx('absolute top-0 bottom-0 left-[-10px] rounded-full w-[3px] bg-secondary-light', className),
	);

	return (
		<motion.span
			layout='position'
			layoutId={`nav-indicator-${groupId}`}
			aria-hidden='true'
			className={classes}
			initial={{ scaleY: 0, opacity: 0 }}
			animate={{ scaleY: 1, opacity: 1 }}
			exit={{ scaleY: 0, opacity: 0 }}
			transition={{ type: 'spring', stiffness: 500, damping: 30, mass: 0.3 }}
		/>
	);
};

export default NavSelectedIndicator;
